export function Can (item) {

    const _user = JSON.parse( localStorage.getItem('user') );
    
    const _permissions = _user._ABILITIES;
    
    const permissionGranted = _permissions.some( (permission) => permission === item );

    return permissionGranted;
}